import { render, staticRenderFns } from "./StockInvoiceStakeholders.vue?vue&type=template&id=2bcebe7f&scoped=true&"
import script from "./StockInvoiceStakeholders.vue?vue&type=script&lang=js&"
export * from "./StockInvoiceStakeholders.vue?vue&type=script&lang=js&"
import style0 from "./StockInvoiceStakeholders.vue?vue&type=style&index=0&id=2bcebe7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcebe7f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
